<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Consultas del cierre
            </h2>
            <small class="title-description">
                Aquí se podrá hacer seguimiento al cierre, una vez que se haya ejecutado
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="refresh()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="shadow mt-3" *ngIf="tareasNocturno.length>0">
    <coky-table [title]="'Tareas del nocturno'" [description]="'Listado de tareas del nocturno'" [data]="tareasNocturno"
        (clickRow)="selectNocturno($event)" [columns]="columnasTareasNocturno" [multipleSelection]="false"
        [pageSizeOptions]="[10,20,30]">
    </coky-table>
</div>